import React from "react";
import { Link } from "gatsby";
// import {
//   FiInstagram,
//   FiFacebook,
//   FiYoutube,
//   FiTwitter,
//   FiLinkedin,
// } from "react-icons/fi";
const Footer = () => {
  return (
    <div className="bg-teal-600 h-16">
      <div className="container px-2 mx-auto flex items-center justify-center h-16">
        <div className="">
          <Link
            to="/"
            className="text-sm text-white no-underline mr-2"
            activeClassName="text-sm text-white no-underline mr-2"
          >
            Ekobé Indaiatuba © 2020
          </Link>
        </div>
        {/* <div className="flex text-white text-xl">
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://facebook.com/EkobeOficial"
          >
            <FiFacebook className="mr-4"></FiFacebook>
          </a>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://instagram.com/EkobeOficial"
          >
            <FiInstagram className="mr-4"></FiInstagram>
          </a>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://linkedin.com/company/EkobeOficial"
          >
            <FiLinkedin className="mr-4"></FiLinkedin>
          </a>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://twitter.com/EkobeOficial"
          >
            <FiTwitter className="mr-4"></FiTwitter>
          </a>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.youtube.com/EkobeOficial"
          >
            <FiYoutube className="mr-4"></FiYoutube>
          </a>
        </div> */}
      </div>
    </div>
  );
};

export default Footer;
